import { byId, isAr, trackEvent, attachCopyButton, setupSegmented, formatCurrency, detectUserCountry } from './calc-common.js';
import Big from 'big.js';
import { getInvoiceTafgeet } from './invoice-currencies.js';

let currentMode = 'add'; // 'add' or 'extract'
let currentRate = 15; // default KSA 15%
let currentCurrency = 'SAR';

const COUNTRY_RATES = {
  sa: {
    rate: 15,
    currency: 'SAR',
    note_ar: 'المملكة العربية السعودية: النسبة الأساسية 15% بموجب لوائح هيئة الزكاة والضريبة والجمارك (ZATCA).',
    note_en: 'Saudi Arabia: 15% standard rate under ZATCA regulations.'
  },
  eg: {
    rate: 14,
    currency: 'EGP',
    note_ar: 'جمهورية مصر العربية: السعر العام 14% وفقاً لقانون الضريبة على القيمة المضافة رقم 67 لسنة 2016 وتعديلاته.',
    note_en: 'Egypt: 14% standard rate under Law No. 67/2016 and its amendments.'
  },
  ae: {
    rate: 5,
    currency: 'AED',
    note_ar: 'دولة الإمارات العربية المتحدة: النسبة الأساسية 5% وفقاً للمرسوم بقانون اتحادي رقم 8 لسنة 2017 (الهيئة الاتحادية للضرائب).',
    note_en: 'United Arab Emirates: 5% standard rate under Federal Decree-Law No. 8/2017 (FTA).'
  },
  bh: {
    rate: 10,
    currency: 'BHD',
    note_ar: 'مملكة البحرين: النسبة القياسية 10% بموجب الجهاز الوطني للإيرادات (NBR).',
    note_en: 'Kingdom of Bahrain: 10% standard rate under National Bureau for Revenue (NBR).'
  },
  om: {
    rate: 5,
    currency: 'OMR',
    note_ar: 'سلطنة عمان: النسبة الأساسية 5% وفقاً لقانون ضريبة القيمة المضافة (جهاز الضرائب).',
    note_en: 'Sultanate of Oman: 5% standard rate under Tax Authority regulations.'
  },
  jo: {
    rate: 16,
    currency: 'JOD',
    note_ar: 'المملكة الأردنية الهاشمية: ضريبة المبيعات العامة 16% (دائرة ضريبة الدخل والمبيعات).',
    note_en: 'Jordan: 16% standard General Sales Tax (ISTD).'
  },
  ma: {
    rate: 20,
    currency: 'MAD',
    note_ar: 'المملكة المغربية: السعر العادي للضريبة على القيمة المضافة 20% (المديرية العامة للضرائب).',
    note_en: 'Morocco: 20% standard VAT rate (DGI).'
  },
  dz: {
    rate: 19,
    currency: 'DZD',
    note_ar: 'الجمهورية الجزائرية: النسبة القياسية 19% (الرسم على القيمة المضافة TVA - المديرية العامة للضرائب).',
    note_en: 'Algeria: 19% standard VAT rate (TVA).'
  },
  tn: {
    rate: 19,
    currency: 'TND',
    note_ar: 'الجمهورية التونسية: النسبة القياسية 19% (الأداء على القيمة المضافة TVA - الإدارة العامة للأداءات).',
    note_en: 'Tunisia: 19% standard VAT rate (TVA).'
  },
  lb: {
    rate: 11,
    currency: 'LBP',
    note_ar: 'الجمهورية اللبنانية: النسبة القياسية 11% (مديرية الضريبة على القيمة المضافة - وزارة المالية).',
    note_en: 'Lebanon: 11% standard VAT rate.'
  },
  sd: {
    rate: 17,
    currency: 'SDG',
    note_ar: 'جمهورية السودان: ضريبة القيمة المضافة 17% (ديوان الضرائب).',
    note_en: 'Sudan: 17% standard VAT rate.'
  },
  mr: {
    rate: 16,
    currency: 'MRU',
    note_ar: 'الجمهورية الإسلامية الموريتانية: النسبة العامة 16% (الضريبة على القيمة المضافة TVA).',
    note_en: 'Mauritania: 16% standard VAT rate (TVA).'
  },
  ps: {
    rate: 16,
    currency: 'JOD',
    note_ar: 'دولة فلسطين: النسبة العامة لضريبة القيمة المضافة 16% (الإدارة العامة للجمارك والمكوس وضريبة القيمة المضافة).',
    note_en: 'Palestine: 16% standard VAT rate.'
  },
  kw: {
    rate: 0,
    currency: 'KWD',
    note_ar: 'دولة الكويت: لا تطبق ضريبة القيمة المضافة حالياً (0%).',
    note_en: 'Kuwait: No standard VAT currently applied (0%).'
  },
  qa: {
    rate: 0,
    currency: 'QAR',
    note_ar: 'دولة قطر: لا تطبق ضريبة القيمة المضافة حالياً (0%).',
    note_en: 'Qatar: No standard VAT currently applied (0%).'
  },
  iq: {
    rate: 0,
    currency: 'IQD',
    note_ar: 'جمهورية العراق: لا تطبق ضريبة قيمة مضافة عامة حالياً (0%).',
    note_en: 'Iraq: No standard VAT currently applied (0%).'
  },
  uk: {
    rate: 20,
    currency: 'GBP',
    note_ar: 'المملكة المتحدة: النسبة القياسية 20% (HMRC VAT standard rate).',
    note_en: 'United Kingdom: 20% standard VAT rate (HMRC).'
  },
  de: {
    rate: 19,
    currency: 'EUR',
    note_ar: 'ألمانيا والاتحاد الأوروبي: النسبة القياسية في ألمانيا 19% (MwSt).',
    note_en: 'Germany: 19% standard VAT rate (MwSt).'
  },
  custom: {
    rate: 15,
    currency: 'SAR',
    note_ar: 'نسبة ضريبية مخصصة حسب إدخالك اليدوي.',
    note_en: 'Custom VAT percentage according to your input.'
  }
};

export function calculateVat() {
  const amountInput = byId('vat-amount');
  const customRateInput = byId('vat-custom-rate');
  const currencySelect = byId('vat-currency');
  const countrySelect = byId('vat-country');

  const activeCountry = countrySelect?.value || 'sa';
  if (activeCountry === 'custom') {
    currentRate = Math.max(0, Number(customRateInput?.value || 0));
  } else {
    currentRate = COUNTRY_RATES[activeCountry]?.rate ?? 15;
    if (customRateInput) {
      customRateInput.value = currentRate;
    }
  }

  currentCurrency = currencySelect?.value || 'SAR';
  const amount = Math.max(0, Number(amountInput?.value || 0));

  let net = new Big(0);
  let vat = new Big(0);
  let gross = new Big(0);

  try {
    const bigAmount = new Big(amount);
    const bigRate = new Big(currentRate).div(100);

    if (currentMode === 'add') {
      // Amount is BEFORE tax
      net = bigAmount;
      vat = bigAmount.times(bigRate);
      gross = net.plus(vat);
    } else {
      // Amount is INCLUSIVE of tax
      gross = bigAmount;
      net = bigAmount.div(new Big(1).plus(bigRate));
      vat = gross.minus(net);
    }
  } catch (err) {
    console.warn('VAT calculation error', err);
  }

  // Update UI
  const heroValEl = byId('vat-hero-val');
  const heroLabelEl = byId('vat-hero-label');
  const heroSubEl = byId('vat-hero-sub');
  const tafgeetEl = byId('vat-tafgeet-val');

  const mainAmount = currentMode === 'add' ? gross : net;
  const mainValFormatted = formatCurrency(mainAmount.toNumber(), currentCurrency);

  if (heroValEl) heroValEl.textContent = mainValFormatted;

  if (currentMode === 'add') {
    if (heroLabelEl) heroLabelEl.textContent = isAr ? 'المبلغ الإجمالي شامل الضريبة' : 'Total Gross (Inclusive of VAT)';
    if (heroSubEl) {
      heroSubEl.textContent = isAr
        ? `قيمة الضريبة المضافة (${currentRate}%): ${formatCurrency(vat.toNumber(), currentCurrency)}`
        : `VAT Amount (${currentRate}%): ${formatCurrency(vat.toNumber(), currentCurrency)}`;
    }
  } else {
    if (heroLabelEl) heroLabelEl.textContent = isAr ? 'المبلغ الصافي قبل الضريبة' : 'Net Amount (Before VAT)';
    if (heroSubEl) {
      heroSubEl.textContent = isAr
        ? `الضريبة المستخرجة (${currentRate}%): ${formatCurrency(vat.toNumber(), currentCurrency)}`
        : `Extracted VAT (${currentRate}%): ${formatCurrency(vat.toNumber(), currentCurrency)}`;
    }
  }

  if (tafgeetEl) {
    tafgeetEl.textContent = getInvoiceTafgeet(gross.toFixed(2), currentCurrency);
  }

  const breakdownNet = byId('vat-b-net');
  const breakdownVat = byId('vat-b-vat');
  const breakdownGross = byId('vat-b-gross');
  const breakdownRate = byId('vat-b-rate');

  if (breakdownNet) breakdownNet.textContent = formatCurrency(net.toNumber(), currentCurrency);
  if (breakdownVat) breakdownVat.textContent = formatCurrency(vat.toNumber(), currentCurrency);
  if (breakdownGross) breakdownGross.textContent = formatCurrency(gross.toNumber(), currentCurrency);
  if (breakdownRate) breakdownRate.textContent = `${currentRate}%`;

  // Legal reference note
  const noteEl = byId('vat-legal-note');
  if (noteEl) {
    noteEl.textContent = isAr ? COUNTRY_RATES[activeCountry]?.note_ar : COUNTRY_RATES[activeCountry]?.note_en;
  }
}

export function initVatCalculator() {
  const container = byId('vat-calculator-app');
  if (!container) return;

  // Mode toggle (Add vs Extract)
  setupSegmented('vat-mode-toggle', (mode) => {
    currentMode = mode;
    const label = byId('vat-amount-label');
    if (label) {
      label.textContent = mode === 'add'
        ? (isAr ? 'المبلغ قبل الضريبة' : 'Amount before VAT')
        : (isAr ? 'المبلغ شامل الضريبة' : 'Amount inclusive of VAT');
    }
    calculateVat();
    trackEvent('tool_interacted', 'vat-calculator', { mode });
  });

  const countrySelect = byId('vat-country');
  const customWrap = byId('vat-custom-rate-wrap');
  const curSelect = byId('vat-currency');

  // Automatic country & currency detection with Saudi Arabia (SA / SAR) fallback
  const userCountryCode = (detectUserCountry() || 'SA').toLowerCase();
  const initialCountryKey = COUNTRY_RATES[userCountryCode] ? userCountryCode : 'sa';
  if (countrySelect) {
    countrySelect.value = initialCountryKey;
  }
  if (curSelect && COUNTRY_RATES[initialCountryKey]?.currency) {
    curSelect.value = COUNTRY_RATES[initialCountryKey].currency;
  }

  if (countrySelect) {
    countrySelect.addEventListener('change', (e) => {
      const cKey = e.target.value;
      if (customWrap) {
        customWrap.style.display = cKey === 'custom' ? 'block' : 'none';
      }
      if (curSelect && COUNTRY_RATES[cKey]?.currency) {
        curSelect.value = COUNTRY_RATES[cKey].currency;
        curSelect.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        calculateVat();
      }
      trackEvent('tool_interacted', 'vat-calculator', { country: cKey });
    });
  }

  ['vat-amount', 'vat-custom-rate', 'vat-currency'].forEach((id) => {
    const el = byId(id);
    if (el) {
      el.addEventListener('input', calculateVat);
      el.addEventListener('change', calculateVat);
    }
  });

  attachCopyButton(byId('vat-copy-btn'), () => {
    const net = byId('vat-b-net')?.textContent || '';
    const vat = byId('vat-b-vat')?.textContent || '';
    const gross = byId('vat-b-gross')?.textContent || '';
    const rate = byId('vat-b-rate')?.textContent || '';
    return isAr
      ? `📋 ملخص حساب ضريبة القيمة المضافة (${rate}):\n• المبلغ الصافي (قبل الضريبة): ${net}\n• قيمة الضريبة: ${vat}\n• المبلغ الإجمالي (شامل الضريبة): ${gross}`
      : `📋 VAT Calculation Summary (${rate}):\n• Net (Before VAT): ${net}\n• VAT Amount: ${vat}\n• Total (Inclusive): ${gross}`;
  });

  const printBtn = byId('vat-print-btn');
  if (printBtn) {
    printBtn.addEventListener('click', () => {
      window.print();
    });
  }

  calculateVat();
  trackEvent('tool_started', 'vat-calculator');
}

if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initVatCalculator);
  } else {
    initVatCalculator();
  }
}
